import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setAutomationEnabledAction = z.enum([
  /** Turn the automation on. */
  "enable",
  /** Stop new triggers; runs already in flight (e.g. on a delay step) finish. */
  "disable",
  /** Stop new triggers and terminate every in-flight run of this automation. */
  "disable_and_cancel",
]);

export type SetAutomationEnabledAction = z.infer<
  typeof setAutomationEnabledAction
>;

export const setAutomationEnabled = {
  name: "setAutomationEnabled" as const,
  input: z.object({
    automationId: zExt.objectId(),
    action: setAutomationEnabledAction,
  }),
  output: z.object({}),
};
